import React, { Component } from "react";
import { bool, func } from "prop-types";
import compose from "ramda/src/compose";
import _map from "lodash/map";
import _includes from "lodash/includes";
import InternetLinkIntermittentForm from "./Intermittent";
import InternetLinkUnavailableForm from "./Unavailable";
import { translate } from "react-i18next";
import { Modal, FloatLabelSelect } from "shared/components";
import IconRepair from "assets/svg/icone-reparo-modal.svg";

// TODO: add translations
const REASONS = {
  INTERMITTENT: "Circuito intermitente",
  PERFORMANCE_ISSUES: "Circuito com falha de performance",
  UNAVAILABLE: "Circuito indisponível",
  PACKAGE_LOSS: "Perda de pacote",
  ALREADY_FIXED: "Causa de queda já normalizada",
};

class ModalInternetLink extends Component {
  state = {
    productLine: REASONS.INTERMITTENT,
  };

  onChangeProductLine = (e) => {
    const { value } = e.target;
    this.setState({ productLine: value });
  };

  getOptions() {
    return _map(REASONS, (reason) => {
      return {
        value: reason,
        label: reason,
      };
    });
  }

  render() {
    const {
      t,
      isCurrentStep,
      onPreviousStep,
      onNextStep,
      onReset,
    } = this.props;
    const { productLine } = this.state;

    return (
      <Modal
        isOpen={isCurrentStep}
        onClose={onReset}
        title={t("MSG_0194")}
        icon={IconRepair}
        ariaHideApp={false}
      >
        <FloatLabelSelect
          label={t("MSG_0216")}
          name="reason"
          value={this.state.productLine}
          options={this.getOptions()}
          onChange={(e) => this.onChangeProductLine(e, "productId")}
        />

        {_includes(
          [
            REASONS.INTERMITTENT,
            REASONS.PERFORMANCE_ISSUES,
            REASONS.PACKAGE_LOSS,
          ],
          productLine
        ) && (
          <InternetLinkIntermittentForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={productLine}
          />
        )}

        {_includes([REASONS.UNAVAILABLE], productLine) && (
          <InternetLinkUnavailableForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={productLine}
          />
        )}

        {_includes([REASONS.ALREADY_FIXED], productLine) && (
          <InternetLinkUnavailableForm
            onReset={onReset}
            onPreviousStep={onPreviousStep}
            onNextStep={onNextStep}
            reason={productLine}
            failureDate={true}
          />
        )}
      </Modal>
    );
  }
}

ModalInternetLink.propTypes = {
  onCreateIncident: func.isRequired,
  onReset: func.isRequired,
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
  isOpen: bool,
};

ModalInternetLink.defaultProps = {
  isOpen: false,
};

const enhance = compose(translate());

export default enhance(ModalInternetLink);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalInternetLink/index.js